<script lang="ts">
	import type { IconName } from '$lib/components/icons/types';
	import Link from '$lib/components/atoms/link/Link.svelte';
	import * as m from '$paraglide/messages';

	interface Props {
		page: number;
		pageHref: (page: number) => string;
		icon?: IconName | undefined;
		disabled?: boolean;
		active?: boolean;
		ariaLabel?: string | null;
		onSelectPage?: (page: number) => void;
	}

	const {
		page,
		pageHref,
		icon,
		disabled = false,
		active = false,
		ariaLabel = null,
		onSelectPage,
	}: Props = $props();

	const ariaLabelKey
		= $derived(ariaLabel
			?? (active
				? m.pagination__aria_labels__page_active({ page })
				: m.pagination__aria_labels__page({ page })));

	const activeClass = $derived(active ? 'bg-white' : undefined); // must be a basic name, otherwise we can't override btn-ghost bg-transparent
</script>

<Link
	button="ghost"
	size="md"
	{icon}
	label={icon ? undefined : `${page}`}
	href={pageHref(page)}
	{disabled}
	{active}
	onclick={() => onSelectPage?.(page)}
	ariaLabel={ariaLabelKey}
	class={activeClass}
	svelteKitPreloadData="off"
/>
